import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';

class LzFiltersDialog extends React.Component {

    onClose() {
        const { onReset, onClose } = this.props;

        // Call reset so that any changes you did are reverted
        if (onReset) {
            onReset();
        }

        // Then call close
        if (onClose) {
            onClose();
        }
    }

    render() {
        const { children, show, onApply, onReset } = this.props;

        if (!show) {
            return '';
        }

        return (
            <Dialog open fullWidth onClose={() => this.onClose()}>

                <DialogTitle>Filters</DialogTitle>

                <DialogContent className="lz-form">
                    {children}
                </DialogContent>

                <DialogActions>
                    <Button onClick={() => this.onClose()}>Close</Button>
                    <Button onClick={onReset}>Reset</Button>
                    <Button onClick={onApply} color="primary" variant="contained">Apply</Button>
                </DialogActions>

            </Dialog>
        );
    }

}

export default LzFiltersDialog;
